import { lazy } from "react";

export const LazyBrandingActions = lazy(() => import("./enrollment/planActions/BrandingActions"));
export const LazyPlanBranding = lazy(() => import("./enrollment/planBranding/PlanBranding"));
export const LazyCustomFormDialog = lazy(() => import("./dialogs/customFormDialog/CustomFormDialog"));
export const LazyPlanActions = lazy(() => import("./enrollment/planActions/PlanActions"));
export const LazyPlanDisclaimer = lazy(() => import("./planDisclaimer/PlanDisclaimer"));
export const LazyCustomWaiveFormDialog = lazy(() => import("./dialogs/customWaiveFormDialog/CustomWaiveFormDialog"));
export const LazyCustomImageUploadDialog = lazy(
	() => import("./dialogs/customImageUploadDialog/CustomImageUploadDialog")
);

// HealthCard Not Active
export { default as HealthCardNotActive } from "./healthCardNotActive/HealthCardNotActive";
export { default as HealthCardAlert } from "./healthCardNotActive/healthCardAlert/HealthCardAlert";
export { default as HealthCardCopy } from "./healthCardNotActive/healthCardCopy/HealthCardCopy";
export { default as RedirectionHealthCard } from "../pages/healthCard/RedirectionHealthCard";

//Auto-Logout
export { default as AutoLogout } from "./autoLogout/AutoLogout";

export { default as DisclaimerTable } from "./disclaimerTable/DisclaimerTable";
export { default as ClinicCardDisclaimerTable } from "./disclaimerTable/clinicCardDisclaimerTable/ClinicCardDisclaimerTable";
export { default as VEBDisclaimer } from "./VEBDisclaimer/VEBDisclaimer";
export { default as KSOPDisclaimer } from "./KSOPDisclaimer/KSOPDisclaimer";

export const LazyCustomTextAreaInput = lazy(() => import("./CustomInput/CustomTextAreaInput"));
export { default as CustomAlertMessage } from "./customAlertMessage/CustomAlertMessage";
export { default as GaugeMeter } from "./gaugeMeter/GaugeMeter";

export { default as BenefitCard } from "./benefitsCardV2/BenefitCardV2";

export { default as LogoLoader } from "./logoLoader/LogoLoader";
export { default as ExplanationOfBenefitsSkeleton } from "./EOBSkeleton/ExplanationOfBenefitsSkeleton";

export { default as ValidationAlertModal } from "./ValidationAlertModel/ValidationAlertModel";
